import React from 'react';
import { Box, Typography } from '@mui/material';

export const NoAccessPage: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        backgroundColor: '#1976d2', // Azul característico de la imagen
        color: 'white',
        textAlign: 'center',
        p: 4,
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      <Box sx={{ zIndex: 1, mb: 10 }}>
        <Typography variant="h3" component="h1" sx={{ fontWeight: 'bold', mb: 2 }}>
          No tienes acceso a esta sección
        </Typography>
        <Typography variant="subtitle1" sx={{ opacity: 0.9 }}>
          Comunícate con el administrador de la aplicación para tu terminal
        </Typography>
      </Box>

      {/* Ilustración simulada con CSS básico para representar las cajas y el operario */}
      <Box sx={{ position: 'absolute', bottom: 0, width: '100%', height: '250px', display: 'flex', justifyContent: 'center', alignItems: 'flex-end' }}>
        {/* Cajas izquierda */}
        <Box sx={{ width: '150px', height: '180px', backgroundColor: '#e3f2fd', position: 'absolute', left: '10%', bottom: 0, border: '1px solid #bbdefb' }} />
        <Box sx={{ width: '100px', height: '120px', backgroundColor: '#bbdefb', position: 'absolute', left: '15%', bottom: '180px', border: '1px solid #90caf9' }} />
        
        {/* Operario (Simulado) */}
        <Box sx={{ width: '60px', height: '180px', backgroundColor: '#42a5f5', position: 'absolute', zIndex: 2, borderRadius: '30px 30px 0 0' }} />
        
        {/* Cajas derecha */}
        <Box sx={{ width: '200px', height: '150px', backgroundColor: '#90caf9', position: 'absolute', right: '30%', bottom: 0, border: '1px solid #64b5f6' }} />
        <Box sx={{ width: '120px', height: '100px', backgroundColor: '#64b5f6', position: 'absolute', right: '35%', bottom: '150px', border: '1px solid #42a5f5' }} />
        <Box sx={{ width: '180px', height: '200px', backgroundColor: '#e3f2fd', position: 'absolute', right: '5%', bottom: 0, border: '1px solid #bbdefb' }} />
      </Box>
    </Box>
  );
};
